import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const updateUserInfo = asyncAction('user/UPDATE_USER_INFO');

// sync actions
export const updateUser = action('user/SET_USER_VALUE');
export const clearState = action('user/CLEAR_STATE');
